export const getGigitData = (gigitLocalId: string) => {
    const gigitData = localStorage.getItem(gigitLocalId);
    if (gigitData) {
        const data = JSON.parse(gigitData);
        const id = data.distinct_id;
        return id ?? '';
    }
}